import { Component } from '@angular/core';

@Component({
    selector: 'pdf-context-menu',
    templateUrl: './pdf-context-menu.component.html',
    styleUrls: ['./pdf-context-menu.component.css'],
    standalone: false
})
export class PdfContextMenuComponent {}
